'use strict'
const imageClientApi = require('../api/uri/index')
const constants = require('../helpers/imageServiceConstants')

imageClientApi.populateGlobalFeatureSupport()

const wixStatic = 'https://static.wixstatic.com/'
const wixStaticWithMedia = 'https://static.wixstatic.com/media/'
const HAS_MEDIA_PREFIX_RE = /^media\//i

const devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1

function getURL(uri) {
    return HAS_MEDIA_PREFIX_RE.test(uri) ? `${wixStatic}${uri}` : `${wixStaticWithMedia}${uri}`
}

function getScaleToFitImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, options) {
    const data = imageClientApi.getData(constants.fittingTypes.SCALE_TO_FIT, {
        id: relativeUrl,
        width: sourceWidth,
        height: sourceHeight,
        name: options && options.name
    }, {
        width: targetWidth,
        height: targetHeight,
        htmlTag: imageClientApi.htmlTag.IMG,
        alignment: imageClientApi.alignTypes.CENTER,
        pixelAspectRatio: devicePixelRatio
    }, options)

    return getURL(data.uri)
}

function getScaleToFillImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, options) {
    const data = imageClientApi.getData(constants.fittingTypes.SCALE_TO_FILL, {
        id: relativeUrl,
        width: sourceWidth,
        height: sourceHeight,
        name: options && options.name,
        focalPoint: {
            x: options && options.focalPoint && options.focalPoint.x,
            y: options && options.focalPoint && options.focalPoint.y
        }
    }, {
        width: targetWidth,
        height: targetHeight,
        htmlTag: imageClientApi.htmlTag.IMG,
        alignment: imageClientApi.alignTypes.CENTER,
        pixelAspectRatio: devicePixelRatio
    }, options)

    return getURL(data.uri)
}

function getCropImageURL(relativeUrl, sourceWidth, sourceHeight, cropX, cropY, cropWidth, cropHeight, targetWidth, targetHeight, options) {
    const data = imageClientApi.getData(constants.fittingTypes.SCALE_TO_FILL, {
        id: relativeUrl,
        width: sourceWidth,
        height: sourceHeight,
        name: options && options.name,
        crop: {
            x: cropX,
            y: cropY,
            width: cropWidth,
            height: cropHeight
        }
    }, {
        width: targetWidth,
        height: targetHeight,
        htmlTag: imageClientApi.htmlTag.IMG,
        alignment: imageClientApi.alignTypes.CENTER,
        pixelAspectRatio: devicePixelRatio
    }, options)

    return getURL(data.uri)
}

module.exports = {
    getScaleToFitImageURL,
    getScaleToFillImageURL,
    getCropImageURL
}